export enum PolicyDialog {
  OnFormValidityChange = 'onFormValidityChange',
}

export class OnFormValidityChange extends CustomEvent<boolean> {
  constructor(value: boolean) {
    super(PolicyDialog.OnFormValidityChange, {
      detail: value,
      bubbles: true,
      composed: true,
    });
  }
}
